import React from 'react';
import MockTestTransformationTraditional from '../../MockTestTransformationTraditional/MockTestTransformationTraditional';

const PortalMockTestTransformationTraditional = () => {
  return <MockTestTransformationTraditional backPath="/portal/test-management" />;
};

export default PortalMockTestTransformationTraditional;
